import { apiServiceProxy } from '../api-proxy';

import type { ApiServiceProxy } from '../api-proxy';

export class Terms {
  constructor(private readonly apiServices: ApiServiceProxy) {}

  public getTerms = () => this.apiServices.get('/terms').then((response) => response.data);

  public saveNewTermsResponse = (accepted: boolean) => this.apiServices.post('/terms', { accepted_term: accepted, application: 'myeduzz' });

  public updateNewTermsResponse = (id: number, accepted: boolean) =>
    this.apiServices.put(`/terms/${id}`, { accepted_term: accepted, application: 'myeduzz' });

  public saveTermsResponse = async (accepted: boolean) => {
    const result = await this.getTerms();
    const term = result?.find((terms: any) => terms.term_id === 1);

    term?.id ? await this.updateNewTermsResponse(term.id, accepted) : await this.saveNewTermsResponse(accepted);
  };
}

const termsService = new Terms(apiServiceProxy);
export default termsService;
